import { Box } from '@mui/material';
import type {
  PSDContext,
  PSDGeneral,
  PSDSieveDetail,
  PSDHydroDetail,
} from '../../../types/psd';
import { PSDSummaryTable } from './PSDSummaryTable';
import { GradationCurveChart } from './charts/GradationCurveChart';

interface Props {
  context: PSDContext;
  general: PSDGeneral;
  sieveDetails: PSDSieveDetail[];
  hydroDetails: PSDHydroDetail[];
}

export const PSDAnalysis = ({ context, general, sieveDetails, hydroDetails }: Props) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <PSDSummaryTable
      context={context} general={general}
      sieveDetails={sieveDetails} hydroDetails={hydroDetails}
    />
    <GradationCurveChart
      general={general}
      sieveDetails={sieveDetails}
      hydroDetails={hydroDetails}
    />
  </Box>
);
